import { render } from "./weibo-bot.vue?vue&type=template&id=07b05b69&ts=true"
import script from "./weibo-bot.vue?vue&type=script&lang=ts"
export * from "./weibo-bot.vue?vue&type=script&lang=ts"

import "./weibo-bot.vue?vue&type=style&index=0&id=07b05b69&lang=scss"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__